import { Tab } from "@headlessui/react";
import React, { useState } from "react";
import { chatWindowTabContents, chatWindowTabs } from "../../utils/data";
import { useRecoilState } from "recoil";
import { selectedPromptState } from "../../utils/recoil";
import { BsStars } from 'react-icons/bs'
import { LuBuilding2 } from 'react-icons/lu'
import { IoMdCode } from 'react-icons/io'
import { RiGraduationCapFill } from 'react-icons/ri'

const SuggestedPrompts = ({setPrompt, handleSubmit}) => {
  const [selected, setSelected] = useState(0);

  const [selectedPrompt, setSelectedPrompt] = useRecoilState(selectedPromptState);

  const handleClick = (title) => {
    setPrompt(title);
    handleSubmit()
  }

  const chatWindowTabs = [
    {
      id: 1,
      title: "Create",
      icon: <BsStars />
    },
    {
      id: 2,
      title: "Explore",
      icon: <LuBuilding2 />
    },
    {
      id: 3,
      title: "Code",
      icon: <IoMdCode />
    },
    {
      id: 5,
      title: "Learn",
      icon: <RiGraduationCapFill />
    }
  ];

  return (
    <div className="mx-auto w-full px-10 md-max:px-5 max-w-4xl flex flex-col gap-5">
      <h1 className="text-[#282F40] text-2xl md-small:text-xl font-medium text-left">How can I help you?</h1>
      <Tab.Group onChange={setSelected}>
        {/* <Tab.List className="flex gap-3 ">
          {chatWindowTabs.map((tab, index) => (
            <Tab
              key={tab.id}
              className={`border text-[#282F40] text-sm flex gap-2 items-center border-[#69A6FF] ${
                selected === index
                  ? "bg-[#267CF490] border-[#69A6FF] outline-none"
                  : "bg-[#69A6FF40]"
              } rounded-full px-5 py-2`}
            >
              {tab.icon}
              {tab.title}
            </Tab>
          ))}
        </Tab.List> */}
        <Tab.Panels className="flex justify-start w-full">
            <Tab.Panel className="flex flex-col gap-1 w-full">
              {chatWindowTabContents[0].map((content) => (
                <>
                  <div onClick={() => handleClick(content.title)} className="hover:bg-[#69A6FF] text-base md-small:text-sm md-max:px-0 text-[#282F40] cursor-pointer flex items-center px-4 py-3 w-full rounded-md">
                    <p key={content.id} className="">
                      {content.title}
                    </p>
                  </div>
                  <hr className="border-b border-[#69A6FF80] w-full" />
                </>
              ))}
            </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default SuggestedPrompts;
